import { inject, Injectable } from '@angular/core';
import { Query } from '@datorama/akita';

import { ExpenseDefaultsState, ExpenseDefaultsStore } from './expense-defaults.store';

@Injectable({ providedIn: 'root' })
export class ExpenseDefaultsQuery extends Query<ExpenseDefaultsState> {
  protected store: ExpenseDefaultsStore;

  constructor() {
    const store = inject(ExpenseDefaultsStore);

    super(store);

    this.store = store;
  }
}
